import { useState, useRef, useEffect } from "react";
import { Row, Col, Card, CardBody, CardHeader, Label, Input, Button  } from 'reactstrap';
import Select from "react-select";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { api } from "../../config";

import { fetchComAuth, fetchComAuthJson } from '../../common/api';
import MapaMemoizado from "./MapaCadastroFeira";

const CadastroMapaRotaExpositor = ({ feiraId, editando }) => {
  const fileInputFundoRef = useRef(null);
  const [showConfirmMapaModal, setShowConfirmMapaModal] = useState(false);
  const [novoMapaPendente, setNovoMapaPendente] = useState(null); // { mapName, paths, width, height }
  const [componentesPerdidosPendentes, setComponentesPerdidosPendentes] = useState([]);
  const [estandesComVinculo, setEstandesComVinculo] = useState([]);
  const [componentesPerdidosSemCadastro, setComponentesPerdidosSemCadastro] = useState([]);
  const [showConfirmResetModal, setShowConfirmResetModal] = useState(false);
  const [componentesMantidos, setComponentesMantidos] = useState([]);
  const [componentesNovos, setComponentesNovos] = useState([]);
  const [modoEdicaoMapa, setModoEdicaoMapa] = useState(false);
  const [estandeEditando, setEstandeEditando] = useState(null);
  const [estandeSelecionado, setEstandeSelecionado] = useState(null);
  const [componentIdEditando, setComponentIdEditando] = useState(null);
  const [expositoresFeiraOptions, setExpositoresFeiraOptions] = useState([]);
  const [expositoresFeira, setExpositoresFeira] = useState([]);
  const [selectedExpositor, setSelectedExpositor] = useState([]);
  const [tiposEspacoOptions, setTiposEspacoOptions] = useState([]);
  const [tiposEspacoFeira, setTiposEspacoFeira] = useState([]);
  const [selectedEstande, setSelectedEstande] = useState([]);
  const [EstandeOpcoes, setEstandeOpcoes] = useState([]);

  const [isSavingMapa, setIsSavingMapa] = useState(false);
  
  const [estandesCadastrados, setEstandesCadastrados] = useState([]);
  const [mapData, setMapData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [deletingMap, setDeletingMap] = useState(false);
  const [fundoUrl, setFundoUrl] = useState('/fundo-mapa.png');
  const [fundo, setFundo] = useState('');
  const [editandoMapa, setEditandoMapa] = useState(false);
  const [selectedComponents, setSelectedComponents] = useState([]);
  const [componentHashes, setComponentHashes] = useState({});
  const [lastSelected, setLastSelected] = useState(null);

  const [pathsRendered, setPathsRendered] = useState(false);
  const mapaRegistradoRef = useRef(false);
  const [formData, setFormData] = useState({
      estande_id: null,
      expositor_id: null
    });

  const svgRef = useRef(null);
  const mapContainerRef = useRef(null);
  
  const [modoEdicaoTexto, setModoEdicaoTexto] = useState(false);
  const [estandeTextoEditando, setEstandeTextoEditando] = useState(null); // Armazena o objeto do estande
  const [posicaoTextoTemporaria, setPosicaoTextoTemporaria] = useState({ x: 0, y: 0 });
  const [posicaoTextoOriginal, setPosicaoTextoOriginal] = useState({ x: 0, y: 0 });

  const handleDeleteMap = async () => {
    try {
      setDeletingMap(true);
      const response = await fetchComAuth(`${api.API_URL}/rota/mapa/excluir/${feiraId}`, {
        method: "DELETE",
      });

      const json = await response.json();
      
      if (json.success) {
        toast.success("Mapa excluído com sucesso!");
        
        // Limpar todos os estados relacionados ao mapa
        setMapData(null);
        setEstandesCadastrados([]);
        setComponentesMantidos([]);
        setComponentesNovos([]);
        setComponentHashes({});
        setLastSelected(null);
        setFundoUrl("");
        setFundo(null);

        mapaRegistradoRef.current = false;
        
        // Limpar a instância do mapa
        if (mapInstance.current) {
            mapInstance.current.destroy();
            mapInstance.current = null;
        }
        
        // Forçar atualização do container
        // setContainerSize(prev => ({ ...prev }));
        
        // Desativar modo de edição
        setModoEdicaoMapa(false);
        // setTimeout(() => window.location.reload(), 1000);
      
      } else {
        toast.error("Erro ao excluir mapa.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erro na comunicação com o servidor.");
    } finally {
      setDeletingMap(false);
      setShowConfirmDeleteModal(false);
    }
  };

  const handleSelectEstande = (selectedOption) => {
    setSelectedEstande(selectedOption);

    if (selectedOption) {
      // Busca o objeto completo do estande na lista de cadastrados
      const estandeCompleto = estandesCadastrados.find(e => e.id === selectedOption.value);

      // Se o estande for encontrado e possuir um expositor_id ou objeto expositor
      if (estandeCompleto && estandeCompleto.expositor_id) {
        const expoId = estandeCompleto.expositor_id;
        
        // Procura a opção correspondente na lista de opções do Select de Expositores
        const expositorOption = expositoresFeiraOptions.find(opt => opt.value === expoId);

        if (expositorOption) {
          setSelectedExpositor(expositorOption);
        } else {
          // Caso o ID exista mas não esteja na lista de opções (opcional)
          setSelectedExpositor(null);
        }
      } else {
        // Se mudar para um estande sem expositor, limpa o campo de expositor
        setSelectedExpositor(null);
      }
    } else {
      setSelectedExpositor(null);
    }
  };

    useEffect(() => {
      const carregarDadosTiposEspaco = async () => {
        try {
          const responseTipos = await fetchComAuth(`${api.API_URL}/tipo-espaco`, {
            method: 'GET'
          });

          const dataTiposEspaco = await responseTipos.json();
    
          setTiposEspacoOptions(dataTiposEspaco.data);
    
          if (feiraId && editando) {
            const responseFeiraTiposEspaco = await fetchComAuth(`${api.API_URL}/feira/tiposEspaco/${feiraId}`, {
              method: 'GET'
            });

            const dataFeiraTiposEspaco = await responseFeiraTiposEspaco.json();
            setTiposEspacoFeira(dataFeiraTiposEspaco.data);
          }
        } catch (err) {
          console.error("Erro ao carregar tipos de espaço:", err);
        }
      };
    
      carregarDadosTiposEspaco();
    }, [feiraId, editando]);

    useEffect(() => {
      const carregarDadosExpositores = async () => {
        setIsLoading(true);
      
        try {
          const response = await fetchComAuth(`${api.API_URL}/feiraExpositor/${feiraId}`, {
            method: 'GET'
          });

          const data = await response.json();
          setExpositoresFeira(data.data || []);
         
          const opcoesFormatadas = data.data.map(expositor => {
            return {
              value: expositor.id,
              label: expositor.nome
            };
          });
          setExpositoresFeiraOptions(opcoesFormatadas);

        } catch (error) {
          setIsLoading(false);
          toast.error("Erro ao buscar expositores");
        } finally {
          setIsLoading(false);
        }
      };
      carregarDadosExpositores();

    }, [feiraId, editando])
    
    const confirmarSalvarNovoMapa = async () => {
      if (!novoMapaPendente) return;

      setIsSavingMapa(true);

      const mapa = {
        feira_id: feiraId,
        mapa: {
          mapName: novoMapaPendente.mapName,
          paths: novoMapaPendente.paths,
          width: novoMapaPendente.width,
          height: novoMapaPendente.height
        },
      };

      const mapaSalvo = {
        feira_id: feiraId,
        mapa: mapa,
        altura: novoMapaPendente.height,
        nome: novoMapaPendente.mapName,
        largura: novoMapaPendente.width,
        prefix: "area",
        fundoUrl: fundoUrl,
        componentes_perdidos: JSON.stringify(componentesPerdidosPendentes.map((c) => c.component_id))
      };

      try {
        const response = await fetchComAuthJson(`${api.API_URL}/rota/mapa/salvar`, {
          method: "POST",
          body: JSON.stringify(mapaSalvo),
        });

        const json = await response.json();
        
        if (json.success) {
          toast.success("Novo mapa salvo com sucesso!");
          setMapData(novoMapaPendente);
          carregarMapaSalvo();
          setModoEdicaoMapa(false);
        } else {
          toast.error("Erro ao salvar o novo mapa.");
        }

      } catch (err) {
        console.error("Erro ao salvar o novo mapa:", err);
        toast.error("Falha na comunicação com o servidor.");
      } finally {
        setIsSavingMapa(false); 
        setShowConfirmMapaModal(false);
        setNovoMapaPendente(null);
        setComponentesPerdidosPendentes([]);
        setEstandesComVinculo([]);
        setComponentesPerdidosSemCadastro([]);
      }
    };

    const limparCamposEspecificos = () => {
      setEstandeEditando(null);
      setEstandeSelecionado(null);
      setSelectedEstande(null);
      setSelectedExpositor(null);
      
      setFormData(prev => ({
        ...prev,
        estande_id: null,
        expositor_id: null
      }));
      setShowConfirmResetModal(false);
    };

    const obterCorDoTipoEspaco = (tipoId) => {
      const tipo = tiposEspacoFeira.find(t => t.tipo_espaco_id === Number(tipoId));
      return tipo?.cor || "#4CAF50";
    };
      
    const carregarMapaSalvo = async () => {
        if (!feiraId) return;

        try {
            const responseMapa = await fetchComAuth(`${api.API_URL}/rota/mapa/${feiraId}?refresh=1`, {
              method: 'GET'
            });
            
            const data = await responseMapa.json();
            const mapa = data.data?.mapa?.mapa;
            
            if (data.data?.fundoURL) {
              setFundoUrl(data.data?.fundoURL || "");
            }

            if (mapa?.mapName && mapa?.paths && mapa?.width && mapa?.height) {
              setMapData({
                mapName: mapa.mapName,
                width: Number(mapa.width),
                height: Number(mapa.height),
                paths: mapa.paths
              });

              const hashMap = {};
              Object.entries(mapa.paths).forEach(([key, value]) => {
                  if (value.hash) {
                  hashMap[key] = value.hash;
                  }
              });
              setComponentHashes(hashMap);

              const estandes = await loadEstantesCadastrados();
              setEstandesCadastrados(estandes);

              // const estandesSemMapa = estandes.filter(e => e.component_id === '' && e.hash_path === '');
        
              const opcoesFormatadas = estandes.map(est => {
                return {
                  value: est.id,
                  label: est.nome
                };
              });
              
              setEstandeOpcoes(opcoesFormatadas);

              } else {
                console.error("Mapa incompleto ou inválido", mapa);
                return;
              }

        } catch (err) {
            console.error("Erro ao carregar mapa ou espaços da feira:", err);
        }
    };

    const importarMapaVendas = async () => {
        if (!feiraId) return;

        try {
            // Buscar o mapa da feira
            const responseMapa = await fetchComAuth(`${api.API_URL}/rota/importar/${feiraId}`, {
            method: 'GET'
            });

            const data = await responseMapa.json();
            
            const mapa = data.data?.mapa?.mapa;
            
            if (data.data?.fundoURL) {
              setFundoUrl(data.data?.fundoURL || "");
            }

            if (mapa?.mapName && mapa?.paths && mapa?.width && mapa?.height) {
              setMapData({
                  mapName: mapa.mapName,
                  width: Number(mapa.width),
                  height: Number(mapa.height),
                  paths: mapa.paths
              });

              const hashMap = {};
              Object.entries(mapa.paths).forEach(([key, value]) => {
                  if (value.hash) {
                  hashMap[key] = value.hash;
                  }
              });
              setComponentHashes(hashMap);

              const estandes = await loadEstantesCadastrados();
              setEstandesCadastrados(estandes);

            } else {
            console.error("Mapa incompleto ou inválido", mapa);
            return;
            }

        } catch (err) {
            console.error("Erro ao carregar mapa ou espaços da feira:", err);
        }
    };

    useEffect(() => {
      if (editando) {
        carregarMapaSalvo();
      }
    }, [editando, tiposEspacoFeira]);
    
    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      setIsLoading(true);
      setError(null);
      setSelectedComponents([]);
      const formDataUpload = new FormData();
      formDataUpload.append("svg", file);
      formDataUpload.append("prefix", 'area_');
      formDataUpload.append("feira_id", feiraId);

      try {
        const response = await fetchComAuth(`${api.API_URL}/rota/mapa/converter`, {
          method: "POST",
          body: formDataUpload,
        });

        const json = await response.json();

        if (!json.data || !json.data.mapName || !json.data.result || !json.data.result.paths) {
          toast.error(json.error || "Formato de dados inválido da API.");
          return;
        }

        if (!json.success) {
          toast.error(json.error || "Falha ao processar o arquivo SVG.");
          return;
        }

        const { result, mapName } = json.data;
        
        setComponentesPerdidosPendentes(json.data.perdidos || []);
        setComponentesPerdidosSemCadastro(json.data.perdidos_sem_estande || []);
        setComponentesMantidos(json.data.mantidos || []);
        setComponentesNovos(json.data.novos || []);
        setEstandesComVinculo(json.data.estandesComVinculos || []);
        
        const hashMap = {};
        Object.entries(result.paths).forEach(([key, value]) => {
          if (value.hash) {
            hashMap[key] = value.hash;
          }
        });
        setComponentHashes(hashMap);

        const novo = {
          mapName: mapName,
          paths: result.paths,
          width: result.width,
          height: result.height,
        };
        
        if (json.data.perdidos.length > 0) {
          setNovoMapaPendente(novo);
          setShowConfirmMapaModal(true);
        } else {
          setMapData(novo);
          
          const mapa = {
            feira_id: feiraId,
            mapa: novo
          };

          const mapaSalvo = {
            feira_id: feiraId,
            mapa: mapa,
            altura: result.height,
            nome: mapName,
            largura: result.width,
            prefix: "area",
            fundoUrl: fundoUrl,
            componentes_perdidos: []
          };

          try {
            const response = await fetchComAuthJson(`${api.API_URL}/rota/mapa/salvar`, {
              method: "POST",
              body: JSON.stringify(mapaSalvo),
            });

            const json = await response.json();
            
            if (json.success) {
              toast.success("Novo mapa salvo com sucesso!");
              setMapData(novoMapaPendente);
              carregarMapaSalvo();
              setModoEdicaoMapa(false);
            } else {
              toast.error("Erro ao salvar o novo mapa.");
            }

          } catch (err) {
            console.error("Erro ao salvar o novo mapa:", err);
            toast.error("Falha na comunicação com o servidor.");
          }
          
        }

      } catch (err) {
        console.error("Erro ao processar SVG:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
        if (!svgRef.current || !mapData?.paths) return;

        const camada = svgRef.current.querySelector('#camada');
        
        if (!camada) return;

        camada.innerHTML = '';

        Object.entries(mapData.paths).forEach(([setorId, pathData]) => {
        const estande = estandesCadastrados?.find(e => e.hash_path === pathData.hash);
        
        let cor = "#DCDCDC"; // Cor padrão para não cadastrados
        if (estande) {
            cor = obterCorDoTipoEspaco(estande.tipo_espaco_id);
        }

        const grupo = document.createElementNS("http://www.w3.org/2000/svg", "g");
        
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", pathData.path);
        path.setAttribute("fill", cor);
        path.setAttribute("stroke", "#333");
        path.setAttribute("stroke-width", "1.5");
        path.setAttribute("data-id", estande?.id || `E${setorId.replace('setor', '')}`);
        path.setAttribute("data-hash", pathData.hash);
        path.setAttribute("data-code", setorId);
        path.setAttribute("data-nome", estande?.nome || "");
        
        path.style.pointerEvents = "auto";
        path.style.cursor = "pointer";
        
        grupo.appendChild(path);
        camada.appendChild(grupo);

        path.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            const componentId = path.getAttribute('data-code');
            
            if (editandoMapa) {
              setSelectedComponents([componentId]);
              updateSelectedRegionsVisual([componentId]);
              limparCamposEspecificos();
              setLastSelected(componentId);
             
            } else {
              
              if (!Array.isArray(estandesCadastrados)) {
                return; // ou continue; se estiver num loop
              }
              const estandeExistente = estandesCadastrados.find(e => e.hash_path === path.getAttribute('data-hash'));
              
              if (estandeExistente) {
                setSelectedComponents([componentId]);
                updateSelectedRegionsVisual([componentId]);
                setLastSelected(componentId);

                setSelectedEstande({
                  value: estandeExistente.id,
                  label: estandeExistente.nome
                });

                if (estandeExistente.expositor) {
                  const exp = estandeExistente.expositor;
                  setSelectedExpositor({
                    value: exp.id,
                    label: exp.nome_mapa || exp.nome || exp.nome_fantasia
                  });
                } else {
                  setSelectedExpositor(null);
                }

                // 3. Atualiza estados técnicos de edição
                setEstandeEditando(estandeExistente.id);
                setEstandeSelecionado(estandeExistente);
                setComponentIdEditando(estandeExistente.component_id);
              }
              else {
                setEstandeEditando(null);
                setSelectedComponents([componentId]);
                updateSelectedRegionsVisual([componentId]);
                limparCamposEspecificos();
                setSelectedExpositor(null);
              }
            }
          });
        });

        setPathsRendered(true);
    }, [mapData, estandesCadastrados, editandoMapa, modoEdicaoTexto, estandeTextoEditando, posicaoTextoTemporaria]);

    const updateSelectedRegionsVisual = (selectedCodes) => {
        if (!svgRef.current) return;
        
        const paths = svgRef.current.querySelectorAll('path[data-code]');
        
        paths.forEach(path => {
        const nodeCode = path.getAttribute('data-code');
        const isSelected = selectedCodes.includes(nodeCode);
        const isRegistered = estandesCadastrados.some(e => e.hash_path === path.getAttribute('data-hash'));
        
        if (isSelected) {
            path.setAttribute("fill", "#FFA500");
            path.setAttribute("stroke", "#FF0000");
            path.setAttribute("stroke-width", "2.5");
        } else {
          if (isRegistered) {
            if (!Array.isArray(estandesCadastrados)) {
              return; // ou continue; se estiver num loop
            }

            const estande = estandesCadastrados.find(e => e.hash_path === path.getAttribute('data-hash'));
            path.setAttribute("fill", obterCorDoTipoEspaco(estande.tipo_espaco_id));
          } else {
            path.setAttribute("fill", "#DCDCDC");
          }

          path.setAttribute("stroke", "#333");
          path.setAttribute("stroke-width", "1.5");
        }
        });
    };
    
    const getExpositorNome = (estande) => {
      const exp = Array.isArray(estande?.expositor) ? estande.expositor[0] : estande?.expositor;
      if (!exp) return "";
      const raw = (exp.nome_mapa && String(exp.nome_mapa).trim())
        ? exp.nome_mapa
        : (exp.nome || exp.nome_fantasia || "");
      return String(raw).trim();
    };

    const wrapText = (text, maxCharsPerLine, maxLines) => {
      const clean = String(text || "").replace(/\s+/g, " ").trim();
      if (!clean) return [];

      const words = clean.split(" ");
      const lines = [];
      let i = 0;

      const pushLine = (line) => {
        // Se uma "palavra" vier enorme (sem espaços), corta
        if (line.length > maxCharsPerLine) {
          lines.push(line.slice(0, Math.max(1, maxCharsPerLine - 1)) + "…");
        } else {
          lines.push(line);
        }
      };

      while (i < words.length && lines.length < maxLines) {
        let line = words[i] || "";
        i++;

        while (i < words.length && (line.length + 1 + words[i].length) <= maxCharsPerLine) {
          line += " " + words[i];
          i++;
        }

        pushLine(line);

        if (lines.length === maxLines && i < words.length) {
          // sobrou conteúdo -> coloca reticências na última linha
          lines[maxLines - 1] =
            lines[maxLines - 1].slice(0, Math.max(1, maxCharsPerLine - 1)).trimEnd() + "…";
          break;
        }
      }

      return lines;
    };

    const renderEstandeText = (path, estande, opts = {}) => {
      if (!path || typeof path.getBBox !== "function") return null;

      const { scale = 1, mode = "full" } = opts;

      const bbox = path.getBBox();
      let centerX = bbox.x + bbox.width / 2;
      let centerY = bbox.y + bbox.height / 2;

        if (estande.posicao_x != null && estande.posicao_y != null) {
          centerX = estande.posicao_x;
          centerY = estande.posicao_y;
        }

        // 3. Edição ao Vivo: Se estiver editando este estande, sobrepõe com a posição temporária
        if (modoEdicaoTexto && Number(estandeTextoEditando?.id) === Number(estande.id)) {
          centerX = posicaoTextoTemporaria.x;
          centerY = posicaoTextoTemporaria.y;
        }

      const maxWidth = bbox.width * 0.9;
      const maxHeight = bbox.height * 0.9;

      // Padrão visual igual ao MapaSVG.js: simples, empilhado, sans-serif :contentReference[oaicite:3]{index=3}
      const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
      group.classList.add("estande-label-group");
      group.style.pointerEvents = "none";

      const createTextElement = (content, x, y, fontSize, fontWeight = "normal", fill = "#000") => {
        const t = document.createElementNS("http://www.w3.org/2000/svg", "text");
        t.setAttribute("x", x);
        t.setAttribute("y", y);
        t.setAttribute("text-anchor", "middle");
        t.setAttribute("font-size", `${fontSize}px`);
        t.setAttribute("font-weight", fontWeight);
        t.setAttribute("fill", fill);
        t.setAttribute("font-family", "sans-serif");
        t.style.pointerEvents = "none";
        t.textContent = content || "";
        return t;
      };

      // Fontes base (sem distorção individual)
      const FONT_ESTANDE = 10; // ajuste se quiser
      const FONT_EXPOSITOR = 9; // ajuste se quiser
      const LINE_SPACING = 12;

      const linha1 = (estande?.nome || estande?.numero || "").toString().trim().toUpperCase();
      const expositorNome = getExpositorNome(estande).toUpperCase();

      const lines = [];

      if (linha1) {
        lines.push({ text: linha1, size: FONT_ESTANDE, weight: "bold", fill: "#000" });
      }

      if (mode === "full" && expositorNome) {
        // Quantos chars cabem (heurística leve, sem ficar pesado)
        const approxChars = Math.max(8, Math.floor(maxWidth / (FONT_EXPOSITOR * 0.6)));

        // 2 linhas pro expositor => total 3 linhas contando linha1
        const EXPO_MAX_LINES = 2; // se quiser 3, troque pra 3
        const expoLines = wrapText(expositorNome, approxChars, EXPO_MAX_LINES);

        expoLines.forEach((l) => {
          lines.push({ text: l, size: FONT_EXPOSITOR, weight: "normal", fill: "#555" });
        });
      }

      if (lines.length === 0) return null;

      // Centraliza o bloco verticalmente
      const totalHeight = (lines.length - 1) * LINE_SPACING;
      const startY = centerY - totalHeight / 2;

      lines.forEach((l, idx) => {
        const y = startY + idx * LINE_SPACING;
        group.appendChild(createTextElement(l.text, centerX, y, l.size, l.weight, l.fill));
      });

      // Aplica scale GLOBAL (mesmo para todos), mantendo o centro
      if (scale !== 1) {
        group.setAttribute(
          "transform",
          `translate(${centerX}, ${centerY}) scale(${scale}) translate(${-centerX}, ${-centerY})`
        );
      }

      return group;
    };

    useEffect(() => {
      if (!svgRef.current || !pathsRendered) return;

      const camada = svgRef.current.querySelector("#camada");
      if (!camada) return;

      const paths = camada.querySelectorAll("path");

      if (!Array.isArray(estandesCadastrados) || paths.length === 0) return;

      // container invisível só pra medir (não “pisca” na tela)
      const measureLayer = document.createElementNS("http://www.w3.org/2000/svg", "g");
      measureLayer.setAttribute("opacity", "0");
      measureLayer.style.pointerEvents = "none";
      camada.appendChild(measureLayer);

      // Guardamos o modo por hash pra manter padrão (full/compact)
      const modeByHash = new Map();

      let globalScale = 1;

      // --- PASSO 1: medir e definir scale global ---
      paths.forEach((path) => {
        const hash = path.getAttribute("data-hash");
        const estandeInfo = estandesCadastrados.find((e) => e.hash_path === hash);
        if (!estandeInfo) return;

        const estande = {
          id: Number(path.getAttribute("data-id")),
          nome: path.getAttribute("data-nome"),
          permite_locacao: Boolean(estandeInfo?.permite_locacao),
          expositor_id: estandeInfo.expositor_id,
          expositor: estandeInfo.expositor || [],
          posicao_x: estandeInfo.posicao_x,
          posicao_y: estandeInfo.posicao_y,
        };

        const bbox = path.getBBox();
        const maxW = bbox.width * 0.9;
        const maxH = bbox.height * 0.9;

        // tenta FULL primeiro
        let label = renderEstandeText(path, estande, { scale: 1, mode: "full" });
        if (!label) return;

        measureLayer.appendChild(label);

        const lb = label.getBBox();
        // escala necessária pra caber (largura e altura)
        let needed = Math.min(
          lb.width > 0 ? (maxW / lb.width) : 1,
          lb.height > 0 ? (maxH / lb.height) : 1,
          1
        );

        // Se ficou pequeno demais, tenta modo compacto (só linha 1),
        // pra não “estragar” a leitura de todo mundo.
        const MIN_ACCEPTABLE = 0.65;
        if (needed < MIN_ACCEPTABLE) {
          label.remove();

          label = renderEstandeText(path, estande, { scale: 1, mode: "compact" });
          measureLayer.appendChild(label);

          const lb2 = label.getBBox();
          needed = Math.min(
            lb2.width > 0 ? (maxW / lb2.width) : 1,
            lb2.height > 0 ? (maxH / lb2.height) : 1,
            1
          );

          modeByHash.set(hash, "compact");
        } else {
          modeByHash.set(hash, "full");
        }

        globalScale = Math.min(globalScale, needed);
        label.remove();
      });

      // remove a camada de medição
      measureLayer.remove();

      // --- PASSO 2: render final com scale global (igual pra todos) ---
      paths.forEach((path) => {
        const grupo = path.parentNode;

        // limpa labels anteriores
        const textos = grupo.querySelectorAll("text, .estande-label-group");
        textos.forEach((t) => t.remove());

        const hash = path.getAttribute("data-hash");
        const estandeInfo = estandesCadastrados.find((e) => e.hash_path === hash);
        if (!estandeInfo) return;

        const estande = {
          id: Number(path.getAttribute("data-id")),
          nome: path.getAttribute("data-nome"),
          permite_locacao: Boolean(estandeInfo?.permite_locacao),
          expositor_id: estandeInfo.expositor_id,
          expositor: estandeInfo.expositor || [],
          posicao_x: estandeInfo.posicao_x,
          posicao_y: estandeInfo.posicao_y,
        };

        const mode = modeByHash.get(hash) || "full";
        const labelGroup = renderEstandeText(path, estande, { scale: globalScale, mode });

        if (labelGroup) grupo.appendChild(labelGroup);
      });
    }, [pathsRendered, estandesCadastrados, modoEdicaoTexto, estandeTextoEditando, posicaoTextoTemporaria,]);

    const loadEstantesCadastrados = async () => {
        try {
        const response = await fetchComAuth(`${api.API_URL}/rota/estandes/${feiraId}?refresh=1`, {
            method: 'GET'
        });
        const data = await response.json();
        
        setEstandesCadastrados(data.data);
        return data.data;
        } catch (err) {
        console.error("Erro ao carregar espaços:", err);
        return [];
        }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      
      setIsLoading(true);
    
      try {
        const dataToSend = {
          components: selectedComponents.map(componentId => ({
              component_id: componentId,
              hash_path: componentHashes[componentId] || null
          })),
          feira_id: feiraId,
          estande_id: selectedEstande ? selectedEstande.value : null,
          expositor_id: selectedExpositor ? selectedExpositor.value : null
       };
        
        const metodo = "PUT";
        const url = `${api.API_URL}/rota/estande-hash/${selectedEstande.value}` ;

        const response = await fetchComAuthJson(
          url, {
            method: metodo,
            body: JSON.stringify(dataToSend)
        });

        if (!response.ok) {
          throw new Error(`Erro: ${response.status}`);
        }
        else {
          const estandes = await loadEstantesCadastrados();
          setEstandesCadastrados(estandes);
          toast.success("Espaço cadastrado com sucesso!");
          // setEstandeOpcoes((prevOpcoes) => 
          //   prevOpcoes.filter(opcao => opcao.value !== selectedEstande.value)
          // );
          setEstandeEditando(null);
          setEstandeSelecionado(null);
          setComponentIdEditando(null);
          setSelectedEstande(null);
          setSelectedExpositor(null);
        
          setFormData({
            estande_id: null,
            expositor_id: null,
            feira_id: feiraId,
          });

          setSelectedComponents([]);

        }
        
        } catch (err) {
            console.error("Erro ao enviar dados:", err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const iniciarEdicaoTexto = () => {
      if (selectedComponents.length !== 1 || !svgRef.current || !mapData) return;

      const componentId = selectedComponents[0];

      const hashDoComponente = mapData.paths[componentId]?.hash;
      if (!hashDoComponente) {
        toast.error("Não foi possível encontrar o hash para o componente selecionado.");
        return;
      }

      const estandeSelecionado = estandesCadastrados.find(e => e.hash_path === hashDoComponente);

      if (!estandeSelecionado) {
        toast.error("Espaço não encontrado nos dados cadastrados para iniciar a edição.");
        return;
      }
      
      let initialPosition;

      // Se já existe uma posição salva, usa ela
      if (estandeSelecionado.posicao_x != null && estandeSelecionado.posicao_y != null) {
        initialPosition = { x: estandeSelecionado.posicao_x, y: estandeSelecionado.posicao_y };
      } else {
        // Se não, calcula a posição central do elemento SVG
        const pathNode = svgRef.current.querySelector(`path[data-code="${componentId}"]`);
        if (pathNode) {
          const bbox = pathNode.getBBox();
          initialPosition = { x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2 };
        } else {
          initialPosition = { x: 0, y: 0 };
          toast.warn("Não foi possível determinar a posição inicial do texto.");
        }
      }

      setEstandeTextoEditando(estandeSelecionado);
      setPosicaoTextoOriginal(initialPosition);
      setPosicaoTextoTemporaria(initialPosition);
      
      setModoEdicaoTexto(true);
    };

    const moverTexto = (direcao) => {
      const incremento = 5; // Move 5 pixels a cada clique
      
      setPosicaoTextoTemporaria(prevPos => {
        switch (direcao) {
          
          case 'up':{
            return { ...prevPos, y: prevPos.y - incremento };
          }
          case 'down':
            return { ...prevPos, y: prevPos.y + incremento };
          case 'left':
            return { ...prevPos, x: prevPos.x - incremento };
          case 'right':
            return { ...prevPos, x: prevPos.x + incremento };
          default:
            return prevPos;
        }
      });
    };

    const handleSalvarPosicaoTexto = async () => {
      if (!estandeTextoEditando) return;

      try {
        setIsLoading(true);
        
        const response = await fetchComAuthJson(`${api.API_URL}/configuracaoFonteRota/${estandeTextoEditando.id}`, {
          method: 'PUT',
          body: JSON.stringify({
            margem_x: posicaoTextoTemporaria.x,
            margem_y: posicaoTextoTemporaria.y,
            feira_id: feiraId,
            estande_id: estandeTextoEditando.id
          }),
        });

        const json = await response.json();
        if (json.success) {
          toast.success("Posição do texto salva com sucesso!");
        } else {
          toast.error("Falha ao salvar a posição do texto.");
        }

        // Atualiza os dados locais para refletir a mudança
        await carregarMapaSalvo(); // Recarrega os dados do mapa para garantir consistência

      } catch (err) {
        console.error(err);
        toast.error("Erro ao salvar a posição.");
        // Reverte para a posição original em caso de erro
        setPosicaoTextoTemporaria(posicaoTextoOriginal);
      } finally {
        setIsLoading(false);
        setModoEdicaoTexto(false);
        setEstandeTextoEditando(null);
      }
    };

    const handleSalvarPosicaoGeral = async () => {
      const svgElement = svgRef.current; // Referência do seu SVG
      if (!svgElement) return;

      const estandesParaAtualizar = [];
      const camada = svgRef.current.querySelector("#camada");
      if (!camada) return;

      const paths = camada.querySelectorAll("path");

      paths.forEach(path => {
        const bbox = path.getBBox();
        const hash = path.getAttribute('data-hash'); // Certifique-se de renderizar o hash no SVG
        
        if (hash) {
          estandesParaAtualizar.push({
            hash: hash,
            posicao_x: bbox.x + bbox.width / 2,
            posicao_y: bbox.y + bbox.height / 2
          });

        }
      });

      try {
        const response = await fetchComAuthJson(`${api.API_URL}/rota/${feiraId}/atualizarPosicoes`, {
          method: 'POST',
          body: JSON.stringify({ estandes: estandesParaAtualizar })
        });
        const json = await response.json();
        
        if (json.success) {
          toast.success("Coordenadas sincronizadas com sucesso!");
        } else {
          toast.error("Falha ao salvar a posição do texto.");
        }

        
      } catch (error) {
        toast.error("Erro ao sincronizar coordenadas.");
      }
    };
    
    const handleCancelarEdicaoTexto = () => {
      setModoEdicaoTexto(false);
      setEstandeTextoEditando(null);
      setPathsRendered(false);
      setTimeout(() => setPathsRendered(true), 0);
    };
    
    return (
      <div style={{ 
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
      }}>
       <ToastContainer closeButton={false} /> 
        
          {!mapData && (
            <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
              <button
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px"
                }}
                onClick={() => importarMapaVendas(true)}
              >
                Buscar Mapa de Vendas
              </button>
            </div>
          )}
       

        {mapData && !modoEdicaoMapa && (
          <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
            {!mapData && (
              <button
                style={{
                  padding: "0.5rem 1rem",
                  backgroundColor: "#4CAF50",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px"
                }}
                onClick={() => importarMapaVendas(true)}
              >
                Buscar Mapa de Vendas
              </button>
            )}
            <button
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#0d6efd",
                color: "#fff",
                border: "none",
                borderRadius: "4px"
              }}
              onClick={() => setModoEdicaoMapa(true)}
            >
              Editar Mapa
            </button>
            <button
              style={{
                padding: "0.5rem 1rem",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "4px"
              }}
              onClick={() => setShowConfirmDeleteModal(true)}
            >
              Excluir Mapa
            </button>
          </div>
        )}

        {showConfirmDeleteModal && (
          <div style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
            display: "flex", justifyContent: "center", alignItems: "center"
          }}>
            <div style={{
              backgroundColor: "#fff", padding: "2rem", borderRadius: "8px",
              maxWidth: "500px", width: "95%", textAlign: "center"
            }}>
              <h4 style={{ color: "#d32f2f" }}>Tem certeza que deseja excluir o mapa atual?</h4>
              <p>Essa ação não poderá ser desfeita.</p>

              <div style={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1.5rem" }}>
                <button
                  onClick={() => setShowConfirmDeleteModal(false)}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px"
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleDeleteMap}
                  disabled={deletingMap}
                  style={{
                    padding: "0.5rem 1rem",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    opacity: deletingMap ? 0.7 : 1
                  }}
                >
                  {deletingMap ? "Excluindo..." : "Sim, excluir"}
                </button>
              </div>
            </div>
          </div>
        )}

        {(!mapData || modoEdicaoMapa) && (
          <Row
            style={{
              padding: "1.5rem",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f8f9fa",
              alignItems: "flex-end",
            }}
          >
            <Col lg={4}>
              <label>Imagem de fundo do mapa:</label>
              <input
                ref={fileInputFundoRef}
                type="file"
                accept="image/png, image/jpeg, image/webp"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setFundoUrl(reader.result);
                    setFundo(e.target.files[0]);
                  };
                  reader.readAsDataURL(file);
                }}
              />
            </Col>

            <Col lg={4}>
              <label>SVG do Mapa dos espaços:</label>
              <input
                type="file"
                label="SVG"
                accept=".svg"
                onChange={handleFileChange}
                disabled={isLoading}
              />
              {isLoading && <p style={{ marginTop: "0.5rem" }}>Processando mapa...</p>}
              {error && (
                <p style={{ color: "red", marginTop: "0.5rem" }}>
                  Erro: {error}
                </p>
              )}
            </Col>

            {modoEdicaoMapa && (
              <Col lg={4}>
                <button
                  onClick={() => setModoEdicaoMapa(false)}
                  style={{
                    marginTop: "1.5rem",
                    padding: "0.5rem 1rem",
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    width: "100%"
                  }}
                >
                  Cancelar
                </button>
              </Col>
            )}
          </Row>
        )}

        <Row style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'stretch' }}>
  
          {/* Seção do Mapa */}
          {mapData ? (
            <Col sm={6} style={{ display: 'flex' }}>
              <div
                ref={mapContainerRef}
                style={{
                  position: "relative",
                  width: "100%",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  overflow: "hidden",
                  borderRadius: "4px",
                  backgroundColor: "#f9f9f9",
                 // flex: 1
                 height: '1000px'
                }}
              >
                {/* {renderMapWithZoom()} */}
                <MapaMemoizado 
                    mapData={mapData} 
                    fundoUrl={fundoUrl} 
                    ref={svgRef} // Passamos a ref para o filho
                />
              </div>
            </Col>
          ) : 
          <Col sm={6} style={{ display: 'flex' }}>
            <div style={{
                width: "100%",
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #ddd",
                borderRadius: "4px",
                backgroundColor: "#f9f9f9",
                overflow: "hidden"
              }}>
                <p>Nenhum mapa carregado. Faça upload dos arquivos.</p>
            </div>
          </Col>}
          
          <Col xl={6} style={{ display: 'flex' }}>

          {/* Formulário de Configuração */}
          <div style={{
            flex: 1,
            padding: "1.5rem",
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#f8f9fa"
            
          }}>
           
            {tiposEspacoFeira.length === 0 && (
              <div style={{
                marginBottom: "1rem",
                padding: "1rem",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                borderRadius: "6px",
                color: "#856404"
              }}>
                <strong>Atenção:</strong> Nenhum tipo de espaço está cadastrado para esta feira.
                <br />
                Cadastre pelo menos um tipo de espaço na aba <strong>Tipos de Espaços</strong> para poder adicionar espaços ao mapa.
              </div>
            )}

            {/* --- BOTÃO PARA INICIAR A EDIÇÃO DE TEXTO --- */}
            {!modoEdicaoTexto && selectedComponents.length === 1 && (
              <div style={{ marginBottom: "1rem" }}>
                <button
                  type="button"
                  onClick={iniciarEdicaoTexto}
                  style={{ padding: "0.5rem 1rem", backgroundColor: "#ffc107", color: "#000", border: "none", borderRadius: "4px", width: "100%" }}
                >
                  Configurar Posição do Texto
                </button>
              </div>
            )}

            {/* --- PAINEL DE CONTROLE DA POSIÇÃO DO TEXTO --- */}
            {modoEdicaoTexto && (
              <Card style={{ marginBottom: '1rem', border: '2px solid #0d6efd' }}>
                <CardHeader>
                  <h5 className="card-title mb-0">Ajustar Posição do Texto</h5>
                  <p className="text-muted mb-0">Estande: {estandeTextoEditando?.nome}</p>
                </CardHeader>
                <CardBody style={{ textAlign: 'center' }}>
                  <div style={{ marginBottom: '10px' }}>
                    <Button color="primary" onClick={() => moverTexto('up')}>
                      <i className="ri-arrow-up-s-line"></i> {/* Usando Remix Icon como exemplo */}
                    </Button>
                  </div>
                  <div>
                    <Button color="primary" style={{ marginRight: '10px' }} onClick={() => moverTexto('left')}>
                      <i className="ri-arrow-left-s-line"></i>
                    </Button>
                    <Button color="primary" style={{ marginLeft: '10px' }} onClick={() => moverTexto('right')}>
                      <i className="ri-arrow-right-s-line"></i>
                    </Button>
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <Button color="primary" onClick={() => moverTexto('down')}>
                      <i className="ri-arrow-down-s-line"></i>
                    </Button>
                  </div>
                  <hr />
                  <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '1rem' }}>
                    <Button color="success" onClick={handleSalvarPosicaoTexto} disabled={isLoading}>
                      {isLoading ? 'Salvando...' : 'Salvar'}
                    </Button>
                    <Button color="secondary" onClick={handleCancelarEdicaoTexto}>
                      Cancelar
                    </Button>
                  </div>
                </CardBody>
              </Card>
            )}
            
            <form onSubmit={handleSubmit}>
              <Row>
                  <Col lg={6}>
                      <div className="mb-3">
                          <Label className="form-label">Espaço</Label>
                          <Select value={selectedEstande} onChange={handleSelectEstande} options={EstandeOpcoes} placeholder="Selecione..." isClearable/>
                      </div>
                  </Col>
                
                  <Col lg={6}>
                      <div className="mb-3">
                          <Label className="form-label">Expositor</Label>
                          <Select value={selectedExpositor} onChange={setSelectedExpositor} options={expositoresFeiraOptions} placeholder="Selecione..." isClearable/>
                      </div>
                  </Col>
                </Row>

              <button
                type="submit"
                disabled={isLoading || selectedComponents.length === 0}
                style={{
                  padding: "0.75rem 1.5rem",
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  opacity: (isLoading || selectedComponents.length === 0) ? 0.6 : 1
                }}
              >
                {isLoading ? "Enviando..." : "Salvar Configuração"}
              </button>

              {selectedComponents.length === 0 && (
                <p style={{ color: "#ff4444", marginTop: "0.5rem" }}>
                  Selecione pelo menos um componente no mapa
                </p>
              )}
            </form>
          </div>
          </Col>
        {/* </div> */}
      </Row>
      {showConfirmMapaModal && (
        <div style={{
          position: "fixed", 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)", 
          zIndex: 9999,
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center",
          padding: "1rem"
        }}>
          <div style={{
            backgroundColor: "#fff", 
            padding: "1.5rem", 
            borderRadius: "8px",
            maxWidth: "900px", 
            width: "95%",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column"
          }}>
            <div style={{overflowY: "auto", flex: 1}}>
              <h4 style={{ 
                marginBottom: "1rem", 
                color: "#d32f2f",
                fontSize: "1.25rem"
              }}>
                ⚠️ ATENÇÃO, IDENTIFICAMOS INCONSISTÊNCIA NO SEU ARQUIVO
              </h4>
              
              <p style={{marginBottom: "1rem"}}>
                Alguns componentes foram identificados como novos, outros foram perdidos e alguns foram mantidos. Confira abaixo:
              </p>
              
              {/* Seção de resumo */}
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: "0.5rem",
                marginBottom: "1rem"
              }}>
                <div className="badge bg-success-subtle text-success" style={{padding: "0.5rem"}}>
                  Novos: {componentesNovos.length}
                </div>
                <div className="badge bg-warning-subtle text-warning" style={{padding: "0.5rem"}}>
                  Perdidos sem cadastro: {componentesPerdidosSemCadastro.length}
                </div>
                <div className="badge bg-danger-subtle text-danger" style={{padding: "0.5rem"}}>
                  Perdidos com cadastro: {componentesPerdidosPendentes.length}
                </div>
                <div className="badge bg-info-subtle text-info" style={{padding: "0.5rem"}}>
                  Mantidos: {componentesMantidos.length}
                </div>
              </div>
              
              {/* Espaços com vínculo - com scroll se necessário */}
              {estandesComVinculo.length > 0 && (
                <div style={{marginBottom: "1rem"}}>
                  <p className="badge bg-danger-subtle text-danger text-uppercase" style={{
                    display: "block",
                    marginBottom: "0.5rem",
                    padding: "0.5rem",
                    width: "100%"
                  }}>
                    Espaços com Reserva ou Venda: {estandesComVinculo.length}
                  </p>
                  <div style={{
                    maxHeight: "100px",
                    overflowY: "auto",
                    border: "1px solid #eee",
                    padding: "0.5rem",
                    fontSize: "0.9rem"
                  }}>
                    {estandesComVinculo.map(item => item.nome).join(', ') || "Nenhum"}
                  </div>
                </div>
              )}
              
              {/* Tabela comparativa */}
              <div style={{ 
                maxHeight: "300px", 
                overflowY: "auto", 
                border: "1px solid #ddd",
                marginBottom: "1rem"
              }}>
                <table style={{ 
                  width: "100%", 
                  borderCollapse: "collapse", 
                  textAlign: "left",
                  fontSize: "0.9rem"
                }}>
                  <thead style={{ 
                    position: "sticky", 
                    top: 0, 
                    backgroundColor: "#f8f9fa", 
                    zIndex: 1 
                  }}>
                    <tr>
                      <th style={{ 
                        padding: "0.75rem", 
                        border: "1px solid #ddd", 
                        backgroundColor: "#fff8e1",
                        color: "#856404"
                      }}>
                        ❌ Perdidos com cadastro
                      </th>
                      <th style={{ 
                        padding: "0.75rem", 
                        border: "1px solid #ddd", 
                        backgroundColor: "#e8f5e9",
                        color: "#2e7d32"
                      }}>
                        ✅ Mantidos
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({ 
                      length: Math.max(
                        componentesPerdidosPendentes.length,
                        componentesMantidos.length
                      ) 
                    }).map((_, i) => (
                      <tr key={i}>
                        <td style={{ 
                          padding: "0.75rem", 
                          border: "1px solid #ddd",
                          backgroundColor: i % 2 === 0 ? "#fff" : "#fff8e133"
                        }}>
                          {componentesPerdidosPendentes[i]?.nome || componentesPerdidosPendentes[i]?.component_id || ""}
                        </td>
                        <td style={{ 
                          padding: "0.75rem", 
                          border: "1px solid #ddd",
                          backgroundColor: i % 2 === 0 ? "#fff" : "#e8f5e933"
                        }}>
                          {componentesMantidos[i] || ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              <p style={{ marginBottom: "1rem", fontSize: "0.95rem" }}>
                Deseja continuar e carregar este novo mapa? Os espaços perdidos não serão renderizados, mas continuam salvos no banco.
              </p>
            </div>
            
            {/* Botões de ação */}
            <div style={{ 
              display: "flex", 
              justifyContent: "flex-end", 
              gap: "1rem",
              paddingTop: "1rem",
              borderTop: "1px solid #eee"
            }}>
              <button
                onClick={() => {
                  setShowConfirmMapaModal(false);
                  setNovoMapaPendente(null);
                  setComponentesPerdidosPendentes([]);
                  setEstandesComVinculo([]);
                  setComponentesPerdidosSemCadastro([]);
                  setComponentesMantidos([]);
                  setComponentesNovos([]);
                }}
                style={{
                  padding: "0.5rem 1.25rem",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e0e0e0"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
              >
                Cancelar
              </button>
              <button
                onClick={confirmarSalvarNovoMapa}
                disabled={isSavingMapa}
                style={{
                  padding: "0.5rem 1.25rem",
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  transition: "background-color 0.2s"
                }}
                onMouseOver={(e) => !isSavingMapa && (e.currentTarget.style.backgroundColor = "#3d8b40")}
                onMouseOut={(e) => !isSavingMapa && (e.currentTarget.style.backgroundColor = "#4caf50")}
              >
                {isSavingMapa ? "Salvando..." : "Sim, continuar"}
              </button>
            </div>
          </div>
        </div>
      )}
  
      {showConfirmResetModal && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999
        }}>
          <div style={{
            background: "#fff", padding: "2rem", borderRadius: "8px",
            maxWidth: "400px", textAlign: "center", boxShadow: "0 0 15px rgba(0,0,0,0.3)"
          }}>
            <p>Você alterou o tipo de espaço. Deseja limpar os dados atuais do cadastro?</p>
            <div style={{ marginTop: "1.5rem", display: "flex", justifyContent: "space-between" }}>
              <button onClick={limparCamposEspecificos} style={{ background: "#e53935", color: "#fff", padding: "0.5rem 1rem", border: "none", borderRadius: "4px" }}>
                Sim, limpar
              </button>
              <button onClick={manterCampos} style={{ background: "#4caf50", color: "#fff", padding: "0.5rem 1rem", border: "none", borderRadius: "4px" }}>
                Não, manter dados
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CadastroMapaRotaExpositor;
